exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".address-list[data-v-36435b8e]{margin-bottom:32px}.address-list__text[data-v-36435b8e]{font-size:16px;line-height:18px;font-weight:500}.address-list__text.grey[data-v-36435b8e]{margin-bottom:16px;color:rgba(0,0,0,.6)}.address-list__text.grey.blue[data-v-36435b8e]{color:#59d}.address-list__text .t-form__radiobox[data-v-36435b8e]{margin-bottom:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36435b8e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/templates/components/ui/addresslist.vue
// module id = 459
// module chunks = 0